import BaseRepository from '@/api/repositories/BaseRepository';

export default class CompanyRepository extends BaseRepository {
	getDamageAssessorCompanyExtraCosts() {
		return this.get(`getExtraCosts`, {});
	}

	saveDamageAssessorCompanyExtraCosts(data) {
		return this.put('saveExtraCosts', {}, data);
	}

	getCompanyContracts() {
		return this.get('contracts', {});
	}

	getCompanyContractByID(id) {
		return this.get(`contracts/${id}`, {}, { responseType: 'arraybuffer' });
	}
}
